import type { CSSProperties } from 'react'

import { cn } from '@/lib/utils/cn'

interface VoiceAvatarProps {
  name?: string
  seed?: number
  size?: number
  active?: boolean
}

const TINTS = [
  'linear-gradient(135deg, #3a3a3a, #1f1f1f)',
  'linear-gradient(135deg, #2d2d2d, #1a1a1a)',
  'linear-gradient(135deg, #424242, #262626)',
  'linear-gradient(135deg, #2a2a2a, #181818)',
  'linear-gradient(135deg, #353535, #1c1c1c)',
]

/**
 * 用户/音色头像（中性灰渐变变体）
 * 通过 seed 取模选择背景，统一显示首字母
 */
export const VoiceAvatar = ({ name, seed = 1, size = 36, active = false }: VoiceAvatarProps) => {
  const bg = TINTS[seed % TINTS.length]
  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center rounded-full font-semibold tracking-[-0.02em] text-white/90 transition-shadow duration-150 [font-family:'Sora',sans-serif]",
        'w-[var(--avatar-size)] h-[var(--avatar-size)] text-[length:var(--avatar-fs)] bg-[image:var(--avatar-bg)]',
        active
          ? 'shadow-[inset_0_0_0_1px_rgba(255,255,255,0.35)]'
          : 'shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)]'
      )}
      style={
        {
          '--avatar-size': `${size}px`,
          '--avatar-fs': `${size * 0.38}px`,
          '--avatar-bg': bg,
        } as CSSProperties
      }
    >
      <span className="relative">{name?.[0] || '?'}</span>
    </div>
  )
}
